<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
            svg(viewBox='0 -50 1280 1020', width='100%', height='100%', preserveAspectRatio='xMidYMid meet')
                g(ref='upperJaw')
                    path(d='M628.783 416L451.848 415.127L463.061 254.963L543.301 171.425L616.769 259.62L628.783 416Z' fill='var(--color-red)')
                    path(d='M438.889 390.55L302 389.895L310.665 266.043L372.701 201.425L429.568 269.682L438.889 390.55Z' fill='var(--color-red)')
                    path(d='M293.335 347.399L187.756 346.816L194.455 251.271L242.293 201.425L286.126 254.036L293.335 347.399Z' fill='var(--color-red)')
                    path(d='M179.383 318.582L94.6289 318.146L100.017 241.447L138.462 201.425L173.631 243.63L179.383 318.582Z' fill='var(--color-red)')
                    path(d='M83.7791 288.31L20.9414 287.947L24.9461 231.042L53.416 201.425L79.4831 232.715L83.7791 288.31Z' fill='var(--color-red)')
                    path(d='M650.047 416L826.983 415.127L815.769 254.963L735.602 171.425L662.134 259.62L650.047 416Z' fill='var(--color-red)')
                    path(d='M839.941 390.55L976.83 389.895L968.165 266.043L906.128 201.425L849.334 269.682L839.941 390.55Z' fill='var(--color-red)')
                    path(d='M985.568 347.399L1091.15 346.816L1084.45 251.271L1036.54 201.425L992.704 254.036L985.568 347.399Z' fill='var(--color-red)')
                    path(d='M1099.45 318.582L1184.2 318.146L1178.82 241.447L1140.44 201.425L1105.2 243.63L1099.45 318.582Z' fill='var(--color-red)')
                    path(d='M1195.05 288.31L1257.89 287.947L1253.96 231.042L1225.41 201.425L1199.35 232.715L1195.05 288.31Z' fill='var(--color-red)')
                g(ref='lowerJaw')
                    path(d='M480.592 497.012H627.526L608.177 632.745L557.259 681.044L506.414 632.745L480.592 497.012Z' fill='var(--color-red)')
                    path(d='M362.389 486.974L472.88 491.339L453.531 611.432L413.597 652.821L377.009 608.377L362.389 486.974Z' fill='var(--color-red)')
                    path(d='M170.064 464.425L264.481 469.589L246.296 574.116L211.526 609.759L180.83 570.552L170.064 464.425Z' fill='var(--color-red)')
                    path(d='M265.354 484.065L359.77 489.229L341.585 593.756L306.815 629.398L276.119 590.192L265.354 484.065Z' fill='var(--color-red)')
                    path(d='M80.5957 444.494L166.865 446.531L153.408 533.746L122.712 564.078L93.6161 532.291L80.5957 444.494Z' fill='var(--color-red)')
                    path(d='M21.166 425L88.3047 426.6L77.8302 494.466L53.9716 518.107L31.2768 493.375L21.166 425Z' fill='var(--color-red)')
                    path(d='M786.389 499.194H639.455L658.804 634.927L709.649 683.226L760.567 634.927L786.389 499.194Z' fill='var(--color-red)')
                    path(d='M904.518 489.156L794.1 493.521L813.376 613.614L853.382 655.003L889.898 610.559L904.518 489.156Z' fill='var(--color-red)')
                    path(d='M1096.91 466.607L1002.43 471.772L1020.68 576.298L1055.45 611.941L1086.08 572.734L1096.91 466.607Z' fill='var(--color-red)')
                    path(d='M1001.63 486.247L907.137 491.411L925.394 595.938L960.164 631.581L990.787 592.374L1001.63 486.247Z' fill='var(--color-red)')
                    path(d='M1186.38 446.676L1100.04 448.713L1113.57 535.928L1144.2 566.26L1173.36 534.473L1186.38 446.676Z' fill='var(--color-red)')
                    path(d='M1245.81 427.182L1178.6 428.782L1189.08 496.649L1212.93 520.289L1235.63 495.557L1245.81 427.182Z' fill='var(--color-red)')
                
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

//import * as basicScroll from 'basicscroll';

export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll();
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});

            this.timeline
                .set(this.$refs.upperJaw, {y: -200})
                .set(this.$refs.lowerJaw, {y: 200})
                .fromTo(this.$refs.upperJaw, {y: -200}, {duration: 1, y: 0}, 0)
                .fromTo(this.$refs.lowerJaw, {y: 200}, {duration: 1, y: 0}, 0);
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 150vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    background-color: #000;
}
</style>
